import React, { useEffect } from 'react'
import Piece from './Piece'
import { animated, useSpring } from 'react-spring/three'
import { Math as ThreeMath } from 'three'

const Puzzle = ({
  config,
  rotation: initialRotation,
  complete: rotateEnabled,
  ...props
}) => {
  // spring to manage rotation and animate it
  const [{ rotation }, setRotation] = useSpring(() => ({
    rotation: initialRotation
  }))

  // update rotation when new value provided
  useEffect(
    () => void setRotation({ rotation: initialRotation }),
    [initialRotation, setRotation]
  )

  return config ? (
    <animated.object3D
      rotation={rotation.interpolate((x, y, z) => [
        ThreeMath.degToRad(x),
        ThreeMath.degToRad(y),
        ThreeMath.degToRad(z)
      ])}
      {...props}>
      {config.groups.map((p) => (
        <Piece
          allowDrag={!rotateEnabled}
          key={p.id}
          {...p}
        />
      ))}
    </animated.object3D>
  ) : null
}

Puzzle.propTypes = {}

export default Puzzle
